export function openModal(name, data = {}) {
  window.dispatchEvent(
    new CustomEvent("app:open-modal", {
      detail: { name, data },
    }),
  );
}

export function openSheet(name, data = {}) {
  window.dispatchEvent(
    new CustomEvent("app:open-sheet", {
      detail: { name, data },
    }),
  );
}

export function closeSheet() {
  window.dispatchEvent(new CustomEvent("sheet:close"));
}
